import { CombinedError } from "urql";

export class NotFound extends Error {
  statusCode = 404;
}

export class ArticleRenderNotSupported extends Error {
  statusCode = 456;
  statusMessage = "Article render not supported";
}

/**
 * Interpret a graphQL error object and throw the most critical error.
 * @param graphQLResult: object
 */
export const throwCorrectStatus = ({ error }: { error?: CombinedError }) => {
  // If there is no error but this function was called, throw NotFound.
  if (!error) throw new NotFound();
  if (error.networkError) throw error.networkError;

  // Pull the status codes out of the error object.
  const statusCodes: Array<number> = error.graphQLErrors
    .map((err) => {
      return err.extensions?.response?.status;
    })
    .filter(Boolean);

  // Sort the status codes and select the highest one.
  const highestStatusCode = statusCodes?.sort((a, b) => b - a)[0];

  // If there was a 5xx error, throw the full object.
  if (highestStatusCode >= 500) {
    throw error;
  }

  throw new NotFound();
};
